import React from "react";
import { useNavigate } from "react-router-dom";
import Page from "../components/Page";
import ScrollToTop from "../components/ScrollToTop";
import { tgChatLink } from "../constants";
import { Button } from "react-bootstrap";

const Maintenance = () => {
  const navigate = useNavigate();
  return (
    <Page>
      <ScrollToTop />
      <h4 style={{ margin: "12px 0" }}>
        <i className="bi bi-gear"></i>&nbsp;Підготовка до нового сезону
      </h4>
      <img
        src="/maintenance.jpeg"
        style={{ width: "100%", height: 360, objectFit: "cover" }}
        alt="Poster"
      />
      <p style={{ marginTop: 12 }}>
        Шановні користувачі!
        <br />
        Застосунок тимчасово недоступний. Триває підготовка до нового сезону.
        Слідкуйте за оголошеннями в нашому чаті.
      </p>
      <Button
        style={{ fontSize: "1.3rem" }}
        onClick={() => (window.location.href = tgChatLink)}
      >
        <i className="bi bi-headset"></i>&nbsp;Перейти до чату
      </Button>
      <Button
        variant="secondary"
        style={{ fontSize: "1.3rem", marginLeft: 8 }}
        onClick={() => navigate("/")}
      >
        <i className="bi bi-house-door"></i>&nbsp;На домашню
      </Button>
    </Page>
  );
};

export default Maintenance;
